import MultiSelectValueViewer from './MultiSelectValueViewer';

export default MultiSelectValueViewer;
